export const PASSWORD_MIN_LENGTH = 12;

/** 0 (empty) to 4 (excellent). Length dominates; variety adds a little. */
export function passwordStrength(password: string): 0 | 1 | 2 | 3 | 4 {
  if (!password) return 0;
  const classes = [/\p{Ll}/u, /\p{Lu}/u, /\d/, /[^\p{L}\d_]/u].filter((re) => re.test(password)).length;
  const unique = new Set(password).size;
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= PASSWORD_MIN_LENGTH) score++;
  if (password.length >= 16 || (password.length >= PASSWORD_MIN_LENGTH && classes >= 3)) score++;
  if (password.length >= 20 || (password.length >= 16 && classes >= 3)) score++;
  if (unique <= 3) score = Math.min(score, 1);
  return Math.max(1, Math.min(4, score)) as 1 | 2 | 3 | 4;
}

export interface PolicyCheck {
  label: string;
  ok: boolean;
}

export function passwordChecks(password: string, confirm: string): PolicyCheck[] {
  return [
    { label: `At least ${PASSWORD_MIN_LENGTH} characters`, ok: password.length >= PASSWORD_MIN_LENGTH },
    { label: "Both passwords match", ok: password.length > 0 && password === confirm },
  ];
}
